import xss from 'xss';
import Vue from 'vue';

Vue.prototype.xss = xss;

export function filterXss(text) {
    if (!text) {
        return '';
    }
    return xss(text);
}

Vue.filter('filterXss', filterXss);
Vue.directive('safe-html', {
    bind(el, binding) {
        el.innerHTML = filterXss(binding.value);
    },
    update(el, binding) {
        el.innerHTML = filterXss(binding.value);
    },
});
